module.exports = __webpack_public_path__ + "img/question16c3.0a10ab74.png";